import { NEUTRAL, RAG } from 'features/dashboard/charts/scoreColour'

export const UPCOMING_TINT = NEUTRAL.soft

export const DEFAULT_DUE_SOON_DAYS = 7

export const TASK_PROGRESS_BUCKETS = [
  { key: 'upcoming', label: 'Upcoming', tint: UPCOMING_TINT, help: 'Not finished yet, and not due for a while.' },
  { key: 'dueSoon', label: 'Due soon', tint: RAG.medium.fg, help: 'Not finished yet, and due within the next few days.' },
  { key: 'overdue', label: 'Overdue', tint: RAG.critical.fg, help: 'Not finished, and the deadline has passed.' },
  { key: 'onHold', label: 'On hold', tint: RAG.none.fg, help: 'Paused on purpose, so it is not counted as overdue.' },
  { key: 'completedLate', label: 'Completed late', tint: RAG.high.fg, help: 'Finished, but after the deadline.' },
  { key: 'completedOnTime', label: 'Completed on time', tint: RAG.low.fg, help: 'Finished on or before the deadline.' },
]

export const bucketTint = key => (TASK_PROGRESS_BUCKETS.find(b => b.key === key) || {}).tint || RAG.none.fg

export const bucketLabel = key => (TASK_PROGRESS_BUCKETS.find(b => b.key === key) || {}).label || key

export const bucketsFromRow = row =>
  TASK_PROGRESS_BUCKETS
    .map(b => ({ ...b, count: Number(row?.[b.key] ?? 0) }))
    .filter(b => b.count > 0)

export const bucketTotal = row =>
  TASK_PROGRESS_BUCKETS.reduce((sum, b) => sum + Number(row?.[b.key] ?? 0), 0)

export const taskBucketsWithWindow = (days = DEFAULT_DUE_SOON_DAYS) =>
  TASK_PROGRESS_BUCKETS.map(b => (b.key === 'dueSoon'
    ? { ...b, help: `Not finished yet, and due in the next ${days} days.` }
    : b.key === 'upcoming'
      ? { ...b, help: `Not finished yet, and not due for more than ${days} days.` }
      : b))
